module.exports = __webpack_public_path__ + "static/img/morainta.72bbba8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/morainta.jpg
// module id = DlbQ
// module chunks = 1